import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import DPlayer from '../../../../../assets/js/dplayer_mod.js';

declare global {
  interface Window {
    Hls?: any;
  }
}

@Component({
  selector: 'app-item-camera-streaming',
  templateUrl: './item-camera-streaming.component.html',
  styleUrls: ['./item-camera-streaming.component.css']
})
export class ItemCameraStreamingComponent implements OnInit, OnDestroy {
  @Input('id') id : any;
  @Input('url') url : any;
  @Input('maintenanceImage') maintenanceImage : string; // Imagen personalizada opcional

  showMaintenanceImage: boolean = false;
  maintenanceImagePath: string = 'assets/cameras/streaming/claro-mantenimiento.jpg';
  private dp: any;
  private videoElement: HTMLVideoElement | null = null;
  private loadingTimeout: any;
  private loadingCheckInterval: any;
  private earlyCheckInterval: any;
  private isVideoPlaying: boolean = false;
  private loadStartTime: number = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    console.log('🚀 ItemCameraStreamingComponent ngOnInit iniciado');
    console.log('🚀 ID:', this.id);
    console.log('🚀 URL:', this.url);
    
    // Interceptar XMLHttpRequest para detectar errores 404
    const self = this;
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;
    
    XMLHttpRequest.prototype.open = function(method: string, url: string | URL, ...rest: any[]) {
      this._url = url;
      return originalXHROpen.apply(this, [method, url, ...rest]);
    };
    
    XMLHttpRequest.prototype.send = function(...args: any[]) {
      const xhr = this;
      const url = xhr._url;
      
      if (url && typeof url === 'string' && url.includes('.m3u8')) {
        xhr.addEventListener('error', function() {
          console.error('❌ Error en XMLHttpRequest para .m3u8:', url);
          setTimeout(() => {
            if (!self.isVideoPlaying) {
              console.warn('⚠️ Mostrando imagen de mantenimiento por error en XMLHttpRequest');
              self.showMaintenanceImage = true;
              self.cdr.detectChanges();
              self.createMaintenanceImageInDOM();
              self.clearLoadingChecks();
            }
          }, 2000);
        });
        
        xhr.addEventListener('load', function() {
          if (xhr.status >= 400) {
            console.error('❌ Error', xhr.status, 'en XMLHttpRequest para .m3u8:', url);
            setTimeout(() => {
              if (!self.isVideoPlaying) {
                console.warn('⚠️ Mostrando imagen de mantenimiento por error', xhr.status, 'en XMLHttpRequest');
                self.showMaintenanceImage = true;
                self.cdr.detectChanges();
                self.createMaintenanceImageInDOM();
                self.clearLoadingChecks();
              }
            }, 2000);
          }
        });
      }
      
      return originalXHRSend.apply(this, args);
    };
  }

  ngAfterViewInit(){
    console.log('🚀 ItemCameraStreamingComponent ngAfterViewInit iniciado');
    
    // Determinar qué imagen de mantenimiento usar (aquí el ID ya está disponible)
    this.determineMaintenanceImage();
    
    var IsiPhone = navigator.userAgent.indexOf("iPhone") != -1 ;
    var IsiPod = navigator.userAgent.indexOf("iPod") != -1 ;
    var IsiPad = navigator.userAgent.indexOf("iPad") != -1 ;
    var IsiPhoneOS = IsiPhone || IsiPad || IsiPod ;
    var video;
    //if (IsiPhoneOS) {
      video = {
	      quality: [
            {
                name: 'HD',
                url: this.url+'/index.m3u8',
                type: 'hls',
            },
            {
                name: '480',
                url: this.url +'_480/index.m3u8',
                type: 'hls',
            },
            {
                name: '720',
                url: this.url +'_720/index.m3u8',
                type: 'hls',
            },
        ],
        defaultQuality: 0,
      }
    /*} else {
      video = {
	      quality: [
            {
                name: 'HD',
                url: this.url+'.flv',
                type: 'flv',
            },
            {
                name: '480',
                url: this.url +'_480.flv',
                type: 'flv',
            },
            {
                name: '720',
                url: this.url +'_720.flv',
                type: 'flv',
            },
        ],
        defaultQuality: 0,
      }
    }*/

    const container = document.getElementById(this.id);
    if (!container) {
      console.error('❌ No se encontró el contenedor con id:', this.id);
      setTimeout(() => {
        const retryContainer = document.getElementById(this.id);
        if (retryContainer) {
          this.initializeDPlayer(retryContainer, video);
        }
      }, 500);
      return;
    }

    this.initializeDPlayer(container, video);
  }

  private initializeDPlayer(container: HTMLElement, video: any) {
    console.log('🚀 Inicializando DPlayer en ItemCameraStreamingComponent...');
    
    this.dp = new DPlayer({
      container: container,
      screenshot: false,
      live: true,
      preload: 'auto',
      autoplay: true,
      fill: true,
      airplay: true,
      mutex: true,
      hotkey: true,
      video: video,
      volume: 0
    });

    console.log('✅ DPlayer inicializado');
    
    // Forzar fondo transparente en todos los elementos de DPlayer
    setTimeout(() => {
      const dplayerElements = container.querySelectorAll('.dplayer, .dplayer-container, .dplayer-video-wrap, .dplayer-video-container, .dplayer-video-current, .dplayer-video-main, .dplayer-video, video');
      dplayerElements.forEach((el: any) => {
        if (el) {
          el.style.backgroundColor = 'transparent';
          el.style.background = 'transparent';
        }
      });
      
      // También aplicar al contenedor principal
      if (container) {
        container.style.backgroundColor = 'transparent';
        container.style.background = 'transparent';
      }
    }, 100);

    // Detectar errores de DPlayer
    this.dp.on('error', () => {
      console.error('Error en DPlayer');
      this.showMaintenanceImage = true;
      this.cdr.detectChanges();
      this.createMaintenanceImageInDOM();
      this.clearLoadingChecks();
    });

    // Detectar errores de HLS
    if (window.Hls && window.Hls.isSupported()) {
      setTimeout(() => {
        try {
          const hlsInstance = this.dp.plugins && this.dp.plugins.hls;
          if (hlsInstance) {
            hlsInstance.on(window.Hls.Events.ERROR, (event: any, data: any) => {
              console.error('Error en HLS:', data);
              if (data.fatal || data.type === 'networkError' || data.type === 'manifestLoadError' || data.details === 'manifestLoadError') {
                console.error('Error fatal de HLS detectado, mostrando imagen de mantenimiento');
                this.showMaintenanceImage = true;
                this.cdr.detectChanges();
                this.createMaintenanceImageInDOM();
                this.clearLoadingChecks();
              }
            });
          }
        } catch (e) {
          console.warn('No se pudo acceder a instancia de HLS:', e);
        }
      }, 1000);
    }

    // Obtener elemento de video
    const getVideoElement = (): HTMLVideoElement | null => {
      if (!this.videoElement) {
        if (this.dp && this.dp.video) {
          this.videoElement = this.dp.video;
        } else {
          this.videoElement = container.querySelector('video') as HTMLVideoElement;
        }
      }
      return this.videoElement;
    };

    // Configurar listeners del video
    const setupVideoListeners = () => {
      const videoEl = getVideoElement();
      if (videoEl) {
        this.loadStartTime = Date.now();
        videoEl.muted = true;
        videoEl.setAttribute('muted', 'true');
        videoEl.setAttribute('playsinline', 'true');

        videoEl.addEventListener('error', (e) => {
          console.error('Error en video:', e);
          const videoError = videoEl.error;
          if (videoError) {
            console.error('Código de error del video:', videoError.code);
            this.showMaintenanceImage = true;
            this.cdr.detectChanges();
            this.createMaintenanceImageInDOM();
            this.clearLoadingChecks();
          }
        });

        videoEl.addEventListener('playing', () => {
          this.isVideoPlaying = true;
          this.showMaintenanceImage = false;
          this.clearLoadingChecks();
        });

        return true;
      }
      return false;
    };

    // Intentar configurar listeners
    let attempts = 0;
    const maxAttempts = 20;
    const trySetup = () => {
      const success = setupVideoListeners();
      if (!success && attempts < maxAttempts) {
        attempts++;
        setTimeout(trySetup, 100);
      }
    };
    trySetup();

    // Verificación agresiva después de 2 segundos
    setTimeout(() => {
      const videoEl = getVideoElement();
      if (videoEl) {
        if (videoEl.readyState === 0 || videoEl.error) {
          console.warn('⚠️ Video sin datos después de 2 segundos - Mostrando imagen');
          this.showMaintenanceImage = true;
          this.cdr.detectChanges();
          this.createMaintenanceImageInDOM();
          this.clearLoadingChecks();
        }
      } else {
        console.warn('⚠️ No se encontró elemento de video - Mostrando imagen');
        this.showMaintenanceImage = true;
        this.cdr.detectChanges();
        this.createMaintenanceImageInDOM();
        this.clearLoadingChecks();
      }
    }, 2000);
  }

  private createMaintenanceImageInDOM() {
    console.log('🔧 createMaintenanceImageInDOM() llamado en ItemCameraStreamingComponent');
    const container = document.getElementById(this.id);
    if (!container) {
      console.warn('⚠️ No se encontró contenedor con id:', this.id);
      return;
    }
    
    let parentContainer = container.parentElement;
    let searchDepth = 0;
    
    // Buscar contenedor padre con position relative
    while (parentContainer && parentContainer !== document.body && searchDepth < 10) {
      const style = window.getComputedStyle(parentContainer);
      if (style.position === 'relative' || style.position === 'absolute' || style.position === 'fixed') {
        break;
      }
      parentContainer = parentContainer.parentElement;
      searchDepth++;
    }
    
    if (!parentContainer || parentContainer === document.body) {
      parentContainer = container.parentElement || document.body;
    }
    
    if (parentContainer) {
      const parentStyle = window.getComputedStyle(parentContainer);
      if (parentStyle.position === 'static') {
        parentContainer.style.position = 'relative';
      }
      
      // Asegurar que tenga altura mínima y ocupe todo el espacio disponible
      const heightValue = parseInt(parentStyle.height);
      const videoElement = parentContainer.querySelector('#' + this.id) as HTMLElement;
      
      // Si hay un elemento de video, usar su altura como referencia
      if (videoElement) {
        const videoHeight = videoElement.offsetHeight || videoElement.clientHeight;
        if (videoHeight > 0) {
          parentContainer.style.height = videoHeight + 'px';
          console.log('✅ Establecido height basado en video:', videoHeight + 'px');
        } else {
          parentContainer.style.minHeight = '400px';
          parentContainer.style.height = '100%';
          console.log('✅ Establecido minHeight: 400px y height: 100%');
        }
      } else {
        if (isNaN(heightValue) || heightValue < 200) {
          parentContainer.style.minHeight = '400px';
          parentContainer.style.height = '100%';
          console.log('✅ Establecido minHeight: 400px y height: 100%');
        }
      }
      
      // Verificar si estamos en un contexto de iframe-streaming (fullscreen)
      const isIframeStreaming = parentContainer.closest('app-iframe-streaming') !== null;
      const positionStyle = isIframeStreaming ? 'fixed' : 'absolute';
      
      // Detectar si es dispositivo móvil
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      // Obtener el tamaño real del contenedor o viewport
      let containerWidth = parentContainer.offsetWidth || window.innerWidth;
      let containerHeight = parentContainer.offsetHeight || window.innerHeight;
      
      // Si está en iframe-streaming, usar el tamaño completo del viewport
      if (isIframeStreaming) {
        containerWidth = window.innerWidth;
        containerHeight = window.innerHeight;
      }
      
      // Deshabilitar scroll en body y html cuando está en iframe-streaming
      if (isIframeStreaming) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.body.style.height = containerHeight + 'px';
        document.body.style.maxHeight = containerHeight + 'px';
        document.body.style.width = containerWidth + 'px';
        document.body.style.maxWidth = containerWidth + 'px';
        document.documentElement.style.height = containerHeight + 'px';
        document.documentElement.style.maxHeight = containerHeight + 'px';
        document.documentElement.style.width = containerWidth + 'px';
        document.documentElement.style.maxWidth = containerWidth + 'px';
      }
      
      let imgContainer = parentContainer.querySelector('.maintenance-image-container') as HTMLElement;
      if (!imgContainer) {
        imgContainer = document.createElement('div');
        imgContainer.className = 'maintenance-image-container';
        
        // Usar el tamaño real del contenedor/viewport
        const widthValue = isIframeStreaming ? containerWidth + 'px' : '100%';
        const heightValue = isIframeStreaming ? containerHeight + 'px' : '100%';
        
        imgContainer.style.cssText = `position: ${positionStyle} !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: ${widthValue} !important; height: ${heightValue} !important; max-width: ${isIframeStreaming ? containerWidth + 'px' : '100%'} !important; max-height: ${isIframeStreaming ? containerHeight + 'px' : '100%'} !important; min-height: ${isIframeStreaming ? containerHeight + 'px' : '400px'} !important; display: flex !important; align-items: center !important; justify-content: center !important; background-color: transparent !important; z-index: 10000 !important; pointer-events: none !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important; box-sizing: border-box !important;`;
        
        // Crear la imagen siempre, pero usar diferentes estilos según el contexto
        const img = document.createElement('img');
        img.src = this.maintenanceImagePath;
        img.alt = 'Cámara en mantenimiento';
        img.className = 'maintenance-image';
        
        // En iframe-streaming, usar cover para llenar completamente sin espacios negros
        // pero también usar background-image como respaldo
        if (isIframeStreaming) {
          // Usar background-image como respaldo y la img con cover
          imgContainer.style.backgroundImage = `url('${this.maintenanceImagePath}')`;
          imgContainer.style.backgroundSize = 'cover';
          imgContainer.style.backgroundPosition = 'center';
          imgContainer.style.backgroundRepeat = 'no-repeat';
          img.style.cssText = `width: 100% !important; height: 100% !important; object-fit: cover !important; object-position: center !important; display: block !important;`;
        } else {
          img.style.cssText = `width: 100% !important; height: 100% !important; object-fit: cover !important; object-position: center !important; display: block !important;`;
        }
        
        imgContainer.appendChild(img);
        
        // Si es iframe-streaming, agregar al body para fullscreen real
        if (isIframeStreaming) {
          document.body.appendChild(imgContainer);
          
          // Actualizar el tamaño cuando cambia la orientación o el tamaño de la ventana
          const updateSize = () => {
            const newWidth = window.innerWidth;
            const newHeight = window.innerHeight;
            imgContainer.style.width = newWidth + 'px';
            imgContainer.style.height = newHeight + 'px';
            imgContainer.style.maxWidth = newWidth + 'px';
            imgContainer.style.maxHeight = newHeight + 'px';
            document.body.style.height = newHeight + 'px';
            document.body.style.width = newWidth + 'px';
            document.documentElement.style.height = newHeight + 'px';
            document.documentElement.style.width = newWidth + 'px';
            
            // Actualizar background-image y la imagen para que se ajuste al nuevo tamaño
            if (isIframeStreaming) {
              imgContainer.style.backgroundImage = `url('${this.maintenanceImagePath}')`;
              imgContainer.style.backgroundSize = 'cover';
              imgContainer.style.backgroundPosition = 'center';
              imgContainer.style.backgroundRepeat = 'no-repeat';
              const img = imgContainer.querySelector('img') as HTMLImageElement;
              if (img) {
                img.style.cssText = `width: 100% !important; height: 100% !important; object-fit: cover !important; object-position: center !important; display: block !important;`;
              }
            }
          };
          window.addEventListener('resize', updateSize);
          window.addEventListener('orientationchange', () => {
            setTimeout(updateSize, 100); // Pequeño delay para que el navegador actualice las dimensiones
          });
        } else {
          parentContainer.appendChild(imgContainer);
        }
        console.log('✅ Contenedor de imagen creado en ItemCameraStreamingComponent', isIframeStreaming ? '(fullscreen)' : '');
      } else {
        // Actualizar contenedor existente
        const updateWidth = isIframeStreaming ? containerWidth + 'px' : '100%';
        const updateHeight = isIframeStreaming ? containerHeight + 'px' : '100%';
        
        imgContainer.style.display = 'flex';
        imgContainer.style.zIndex = '10000';
        imgContainer.style.position = positionStyle;
        imgContainer.style.top = '0';
        imgContainer.style.left = '0';
        imgContainer.style.right = '0';
        imgContainer.style.bottom = '0';
        imgContainer.style.width = updateWidth;
        imgContainer.style.height = updateHeight;
        imgContainer.style.maxWidth = isIframeStreaming ? containerWidth + 'px' : '100vw';
        imgContainer.style.maxHeight = isIframeStreaming ? containerHeight + 'px' : '100vh';
        imgContainer.style.visibility = 'visible';
        imgContainer.style.opacity = '1';
        imgContainer.style.overflow = 'hidden';
        imgContainer.style.margin = '0';
        imgContainer.style.padding = '0';
        imgContainer.style.boxSizing = 'border-box';
        
        // Actualizar también la imagen para ajustar correctamente
        if (isIframeStreaming) {
          // Actualizar background-image y la imagen
          imgContainer.style.backgroundImage = `url('${this.maintenanceImagePath}')`;
          imgContainer.style.backgroundSize = 'cover';
          imgContainer.style.backgroundPosition = 'center';
          imgContainer.style.backgroundRepeat = 'no-repeat';
          const img = imgContainer.querySelector('img') as HTMLImageElement;
          if (img) {
            img.style.cssText = `width: 100% !important; height: 100% !important; object-fit: cover !important; object-position: center !important; display: block !important;`;
          }
        } else {
          const img = imgContainer.querySelector('img') as HTMLImageElement;
          if (img) {
            img.style.cssText = `width: 100% !important; height: 100% !important; object-fit: cover !important; object-position: center !important; display: block !important;`;
          }
        }
      }
    }
  }

  private determineMaintenanceImage() {
    // Si se proporciona una imagen personalizada, usarla
    if (this.maintenanceImage) {
      this.maintenanceImagePath = this.maintenanceImage;
      return;
    }
    
    // Lista de IDs de cámaras que deben usar la imagen de muni-lima
    // Solo se usa muni-lima-mantenimiento.jpg si el ID coincide exactamente
    const muniLimaCameraIds: number[] = [
      299, 298, 297, 300, 296, 295
    ];
    
    const cameraId = this.id;
    // Extraer solo el número del ID (puede venir como "stream_294" o solo "294")
    let cameraIdNum: number | null = null;
    let cameraIdStr = '';
    
    if (cameraId != null) {
      const idStr = String(cameraId).trim();
      // Si tiene prefijo "stream_", extraer solo el número
      const match = idStr.match(/(\d+)$/);
      if (match) {
        cameraIdNum = Number(match[1]);
        cameraIdStr = match[1];
      } else {
        // Si no tiene prefijo, intentar convertir directamente
        cameraIdNum = Number(idStr);
        cameraIdStr = idStr;
      }
    }
    
    console.log('🔍 [determineMaintenanceImage] ID recibido:', cameraId, 'Tipo:', typeof cameraId);
    console.log('🔍 [determineMaintenanceImage] Número extraído:', cameraIdNum, 'String extraído:', cameraIdStr);
    console.log('🔍 [determineMaintenanceImage] IDs muni-lima:', muniLimaCameraIds);
    
    // Verificar si el ID está en la lista de cámaras muni-lima (solo comparar el número)
    let isMuniLimaById = false;
    
    if (cameraIdNum !== null && !isNaN(cameraIdNum)) {
      // Comparar solo el número extraído
      isMuniLimaById = muniLimaCameraIds.indexOf(cameraIdNum) !== -1;
      console.log('🔍 [determineMaintenanceImage] Comparación numérica:', cameraIdNum, 'en lista:', isMuniLimaById);
    }
    
    console.log('🔍 [determineMaintenanceImage] ¿Es muni-lima?', isMuniLimaById);
    
    if (isMuniLimaById) {
      this.maintenanceImagePath = 'assets/cameras/streaming/muni-lima-mantenimiento.jpg';
      console.log('✅ [determineMaintenanceImage] USANDO muni-lima-mantenimiento.jpg para cámara ID:', cameraId);
    } else {
      // Imagen por defecto cuando hay error
      this.maintenanceImagePath = 'assets/cameras/streaming/claro-mantenimiento.jpg';
      console.log('✅ [determineMaintenanceImage] USANDO claro-mantenimiento.jpg para cámara ID:', cameraId);
    }
    
    console.log('🖼️ [determineMaintenanceImage] Imagen final:', this.maintenanceImagePath);
  }

  private clearLoadingChecks() {
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
    if (this.loadingCheckInterval) {
      clearInterval(this.loadingCheckInterval);
      this.loadingCheckInterval = null;
    }
    if (this.earlyCheckInterval) {
      clearInterval(this.earlyCheckInterval);
      this.earlyCheckInterval = null;
    }
  }

  ngOnDestroy() {
    this.clearLoadingChecks();
    if (this.dp) {
      this.dp.destroy();
    }
  }
}
